import SendGiftButtons from '../../components/organism/orders/send-gift-buttons.vue'
import PageHeadlineWithFourSteps from '../../components/molecules/headlines/PageHeadlineWithFourSteps'

export default {
  components: {
    SendGiftButtons,
    PageHeadlineWithFourSteps
  },
  data() {
    return {
      flowLineContents: {
        steps: ['作成', 'プレビュー', '確認', '完了'],
        activeStep: 4
      }
    }
  },
  methods: {
    onClickMoveToOtherScreen(path) {
      window.location.href = path
    }
  }
}
